import { render } from "./SyncTaskResults.vue?vue&type=template&id=5541b200"
import script from "./SyncTaskResults.vue?vue&type=script&lang=js"
export * from "./SyncTaskResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__